import { openDB } from 'idb';

const DB_NAME = 'QeeperDB';
const DB_VERSION = 1;
const STORE_NAME = 'QeeperStore';

export async function initDB() {
  const db = await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
  return db;
}

export async function setIndexDBItem(key: string, value: any) {
  const db = await initDB();
  await db.put(STORE_NAME, value, key);
}

export async function getIndexDBItem(key: string) {
  const db = await initDB();
  return await db.get(STORE_NAME, key);
}

export async function deleteIndexDBItem(key: string) {
  const db = await initDB();
  await db.delete(STORE_NAME, key);
}
